<div class="porta-sub-inst-seach py-6" id="porta-sub-inst-seach">
  <div class="container-fluid pl-5 pr-5">


    <!-- Carrusel nativo (mismo formato que destination-big/promotions-big). Muestra 3 y avanza de a 1 por click. -->
    <div class="native-carousel position-relative py-5">

          <!-- <p class="pl-3" style="font-family: 'Poppins', sans-serif;font-weight: 600; font-size: 38px;color: black;">Ferias</p> -->

      <button type="button" class="carousel-arrow carousel-arrow-left" (click)="carousel.prev()" aria-label="Anterior">
        <i class="bi bi-chevron-left"></i>
      </button>

      <div class="native-carousel-viewport">
        <div class="native-carousel-track"
             [style.width.%]="carousel.trackWidthPercent"
             [style.transform]="'translateX(' + carousel.translatePercent + '%)'"
             [style.transition]="carousel.transitionEnabled ? 'transform 0.7s ease' : 'none'">
          <div class="native-carousel-slide text-center p-3" [style.width.%]="carousel.slideWidthPercent" *ngFor="let slide of carousel.extended" id="image-to-cover">
            <div class="image-position position-relative porta-sub-inst-seach-imag">
              <span class="image-container bd-placeholder-img card-img-top position-relative">
                <img
                        usbLazyLoadImage
                        loading="lazy"
                        [lazyImage]="routeUploadFile + slide.data.image"
                        class="bd-placeholder-img card-img-top"
                        alt="{{ slide.data.title }}">
                          <div class="placeholder position-absolute"
                                [ngStyle]="{'background-color':clientSettingGlobal?.color_main_1}"
                                role="status"
                                style=" top: 50%; left: 50%; transform: translate(-50%, -50%);">
                          </div>
                <div class="capa" [ngStyle]="{'background':clientSettingGlobal?.color_main_3}"></div>
              </span>
              <div class="porta-sub-inst-seach-box text-center">
                <ul>
                  <li>
                    <img
                          loading="lazy"
                          src="{{ routeUploadFile+slide.data.logo }}"
                          class="img-fluid"
                          alt="logo">
                  </li>
                </ul>
              </div>
              <h5 class="mb-1 text-left pt-4 px-md-3 text-center text-uppercase">{{ slide.data.title }}</h5>
              <h6 class="mb-1 text-left mb-6 px-md-3 text-center">{{ slide.data.subtitle }}</h6>
              <hr>
              <p class="pb-5 pl-4 pr-4">{{ slide.data.description }}</p>

            </div>
            <div class="text-center">
                <button
                        class="btn rounded-pill m-3"
                        style="color:black; height: 55px;  color: white"
                        [ngStyle]="{'background-color': clientSettingGlobal?.color_main_1}"
                        (click)="articleRedirect(slide.realIndex + 1)"
                >
                  ver
                </button>
            </div>
          </div>
        </div>
      </div>

      <button type="button" class="carousel-arrow carousel-arrow-right" (click)="carousel.next()" aria-label="Siguiente">
        <i class="bi bi-chevron-right"></i>
      </button>
    </div>

    <!-- Grilla anterior (3 columnas fijas, sin carrusel). Se deja comentada hasta confirmar que el carrusel nativo quedó bien. -->
    <!--
    <div class="row py-5">
      <ng-container *ngFor="let article of articleSmallArr; let i = index;">
        <div class=" col-md-4 col-sm-12 col-12  text-center p-3" id="image-to-cover">
          <div class="image-position position-relative porta-sub-inst-seach-imag">
            <span class="image-container bd-placeholder-img card-img-top position-relative">
              <img
                      usbLazyLoadImage
                      loading="lazy"
                      [lazyImage]="routeUploadFile + article.image"
                      class="bd-placeholder-img card-img-top"
                      alt="{{ article.title }}">
                        <div class="placeholder position-absolute"
                              [ngStyle]="{'background-color':clientSettingGlobal?.color_main_1}"
                              role="status"
                              style=" top: 50%; left: 50%; transform: translate(-50%, -50%);">
                        </div>
              <div class="capa" [ngStyle]="{'background':clientSettingGlobal?.color_main_3}"></div>
            </span>
            <div class="porta-sub-inst-seach-box text-center">
              <ul>
                <li>
                  <img
                        loading="lazy"
                        src="{{ routeUploadFile+article.logo }}"
                        class="img-fluid"
                        alt="logo">
                </li>
              </ul>
            </div>
            <h5 class="mb-1 text-left pt-4 px-md-3 text-center text-uppercase">{{ article.title }}</h5>
            <h6 class="mb-1 text-left mb-6 px-md-3 text-center">{{ article.subtitle }}</h6>
            <hr>
            <p class="pb-5 pl-4 pr-4">{{ article.description }}</p>

          </div>
          <div class="text-center">
              <button
                      class="btn rounded-pill m-3"
                      style="color:black; height: 55px;  color: white"
                      [ngStyle]="{'background-color': clientSettingGlobal?.color_main_1}"
                      (click)="articleRedirect(i + 1)"
              >
                ver
              </button>
          </div>
        </div>
      </ng-container>
    </div>
    -->
  </div>
</div>

  <!-- <div class="porta-sub-inst-seach pb-5">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center">
          <button class="boton"
            [ngStyle]="{'color':clientSettingGlobal?.color_main_1, 'border':  '1px solid' + clientSettingGlobal?.color_main_1}">
            VER +
          </button>
        </div>
      </div>
    </div>
  </div> -->
